var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orderInfoAD" },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        attrs: { id: "container" },
      }),
      _c("el-row", { attrs: { gutter: 20 } }, [
        _c(
          "div",
          { staticClass: "bg-purple bcGrey" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "grey padding10",
                attrs: { "label-position": "left", "label-width": "auto" },
              },
              [
                _c(
                  "el-tabs",
                  {
                    staticClass: "marginBottom10 marginLeft10",
                    model: {
                      value: _vm.ordMain.zdelivery,
                      callback: function ($$v) {
                        _vm.$set(_vm.ordMain, "zdelivery", $$v)
                      },
                      expression: "ordMain.zdelivery",
                    },
                  },
                  [
                    _c("el-tab-pane", {
                      attrs: { label: "同城配送", name: "0" },
                    }),
                    _c("el-tab-pane", {
                      attrs: { label: "顾客自提", name: "1" },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "线上店铺" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "270px" },
                      attrs: { type: "text", readonly: "" },
                      model: {
                        value: _vm.ordMain.sshop,
                        callback: function ($$v) {
                          _vm.$set(_vm.ordMain, "sshop", $$v)
                        },
                        expression: "ordMain.sshop",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "配送/自提门店" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v("配送/自提门店 "),
                    ]),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择配送门店",
                          filterable: "",
                        },
                        on: { change: _vm.handleSelectStore },
                        model: {
                          value: _vm.store,
                          callback: function ($$v) {
                            _vm.store = $$v
                          },
                          expression: "store",
                        },
                      },
                      _vm._l(_vm.storeList, function (item) {
                        return _c("el-option", {
                          key: item.sid,
                          attrs: { label: item.cname, value: item.sid },
                        })
                      }),
                      1
                    ),
                  ],
                  2
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "选择城市" } },
                  [
                    _c("el-cascader", {
                      attrs: { options: _vm.options, props: _vm.defaultProps },
                      on: { change: _vm.selectCity },
                      model: {
                        value: _vm.address,
                        callback: function ($$v) {
                          _vm.address = $$v
                        },
                        expression: "address",
                      },
                    }),
                  ],
                  1
                ),
                _vm.ordMain.zdelivery === "0"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "收货地址" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              filterable: "",
                              "filter-method": _vm.getReceivingAddress,
                              placeholder: "请选择",
                            },
                            on: { change: _vm.changeInfo },
                            model: {
                              value: _vm.ordMain.ccustomerAddr,
                              callback: function ($$v) {
                                _vm.$set(_vm.ordMain, "ccustomerAddr", $$v)
                              },
                              expression: "ordMain.ccustomerAddr",
                            },
                          },
                          _vm._l(_vm.infoOptions, function (item) {
                            return _c(
                              "el-option",
                              {
                                key: item.id,
                                attrs: { label: item.name, value: item },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex directionColumn" },
                                  [
                                    _c("div", [_vm._v(_vm._s(item.name))]),
                                    _c("div", { staticClass: "grey" }, [
                                      _vm._v(_vm._s(item.address)),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "详细地址" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v("详细地址 "),
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "270px" },
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.ordMain.creceiveAddr,
                        callback: function ($$v) {
                          _vm.$set(_vm.ordMain, "creceiveAddr", $$v)
                        },
                        expression: "ordMain.creceiveAddr",
                      },
                    }),
                  ],
                  2
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "收货人", prop: "ccustomerName" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v("收货人 "),
                    ]),
                    _c("el-input", {
                      model: {
                        value: _vm.ordMain.ccustomerName,
                        callback: function ($$v) {
                          _vm.$set(_vm.ordMain, "ccustomerName", $$v)
                        },
                        expression: "ordMain.ccustomerName",
                      },
                    }),
                  ],
                  2
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号", prop: "ccustomerPhone" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _vm._v("手机号 "),
                    ]),
                    _c("el-input", {
                      staticClass: "w150",
                      model: {
                        value: _vm.ordMain.ccustomerPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.ordMain, "ccustomerPhone", $$v)
                        },
                        expression: "ordMain.ccustomerPhone",
                      },
                    }),
                  ],
                  2
                ),
                _c(
                  "el-form-item",
                  { staticClass: "marginTop10", attrs: { label: "用户备注" } },
                  [
                    _c("el-input", {
                      attrs: { autosize: "", type: "textarea" },
                      model: {
                        value: _vm.ordMain.corderRemark,
                        callback: function ($$v) {
                          _vm.$set(_vm.ordMain, "corderRemark", $$v)
                        },
                        expression: "ordMain.corderRemark",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "marginTop10", attrs: { label: "内部备注" } },
                  [
                    _c("el-input", {
                      attrs: { autosize: "", type: "textarea" },
                      model: {
                        value: _vm.ordMain.cremark,
                        callback: function ($$v) {
                          _vm.$set(_vm.ordMain, "cremark", $$v)
                        },
                        expression: "ordMain.cremark",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { label: "" } }, [
                  _c("span", [_vm._v("门店与商品信息请在拣货单中修改")]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.submit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }